module.exports = "/static/media/calls-3.a72ad75d.svg";